export const ASSET_TYPE_VIDEO = 3;
export const ASSET_TYPE_YOUTUBE = 4;
